var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoSellerPersonFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 21C3.44772 21 3 20.5523 3 20V18.5625C3 16.9375 3.83125 15.625 5.49375 14.625C7.15625 13.625 9.325 13.125 12 13.125C14.7 13.125 16.875 13.625 18.525 14.625C20.175 15.625 21 16.9375 21 18.5625V20C21 20.5523 20.5523 21 20 21H4ZM12 12C10.75 12 9.6875 11.5625 8.8125 10.6875C7.9375 9.8125 7.5 8.75 7.5 7.5C7.5 6.225 7.9375 5.15625 8.8125 4.29375C9.6875 3.43125 10.75 3 12 3C13.275 3 14.3437 3.43125 15.2062 4.29375C16.0687 5.15625 16.5 6.225 16.5 7.5C16.5 8.75 16.0687 9.8125 15.2062 10.6875C14.3437 11.5625 13.275 12 12 12Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSellerPersonFill);
export default __webpack_public_path__ + "static/media/ico-seller-person-fill.080ed81af4aef42ecb9cdbda4bb5bd9f.svg";
export { ForwardRef as ReactComponent };